import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import {
  PaymentReturnBill,
  PaymentReturnInsertData,
  PaymentReturnVm,
  ApiResponse,
} from '@/api/types'

/**
 * Payment Return management service
 * Handles all payment return-related API operations
 */
export class PaymentReturnService {
  /**
   * Get bills by vendor ID
   */
  async getBillsByVendorId(vendorId: number): Promise<PaymentReturnBill[]> {
    const url = endpoints.paymentReturn.getBillsByVendorId(vendorId)
    const response = await apiClient.get<ApiResponse<PaymentReturnBill[]> | PaymentReturnBill[] | any>(url)
    
    if (Array.isArray(response.data)) {
      return response.data
    }
    if ('data' in response.data && Array.isArray(response.data.data)) {
      return response.data.data
    }
    return []
  }

  /**
   * Get insert data for payment return
   */
  async getInsertData(branchId: number, billId: number): Promise<PaymentReturnInsertData> {
    const url = endpoints.paymentReturn.getInsertData(branchId, billId)
    const response = await apiClient.get<ApiResponse<PaymentReturnInsertData> | PaymentReturnInsertData | any>(url)
    
    if (response.data && typeof response.data === 'object') {
      if ('data' in response.data) {
        return response.data.data as PaymentReturnInsertData
      }
      return response.data as PaymentReturnInsertData
    }
    
    throw new Error('Invalid response format from GetInsertData')
  }

  /**
   * Save payment return (POST)
   */
  async savePaymentReturn(data: PaymentReturnVm): Promise<any> {
    const url = endpoints.paymentReturn.save
    console.log('🔵 [PaymentReturnService] POST Request URL:', url)
    console.log('🔵 [PaymentReturnService] POST Request Data:', JSON.stringify(data, null, 2))
    console.log('🔵 [PaymentReturnService] POST Request Data Object:', data)
    
    try {
      const response = await apiClient.post<ApiResponse<any> | any>(url, data)
      console.log('✅ [PaymentReturnService] POST Response:', response)
      return response.data
    } catch (error: any) {
      console.error('❌ [PaymentReturnService] POST Error:', error)
      console.error('❌ [PaymentReturnService] POST Error Response:', error.response)
      console.error('❌ [PaymentReturnService] POST Error Data:', error.response?.data)
      throw error
    }
  }

  /**
   * Update payment return (PUT)
   */
  async updatePaymentReturn(data: PaymentReturnVm): Promise<any> {
    const url = endpoints.paymentReturn.update
    const response = await apiClient.put<ApiResponse<any> | any>(url, data)
    return response.data
  }
}

export const paymentReturnService = new PaymentReturnService()
